/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { SOCIAL_VIDEO_FORMATS } from '@repo/config/social-video';
import { z } from 'zod';

export const socialVideoFormatSchema = z.enum(SOCIAL_VIDEO_FORMATS);

export type ISocialVideoFormat = z.infer<typeof socialVideoFormatSchema>;
